module.exports = __webpack_public_path__ + "img/horizontal_4_1_3.fb80ae09.png";